@if (this.gridView === 'gallery') {
    <prl-zones-gallery [lightZones]="zones"/>
} @else if (this.gridView === 'list') {
    <prl-zones-list [lightZones]="zones"/>
}